module.exports = __webpack_public_path__ + "static/media/wheelShadow.2fb6a6d9.svg";